import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { StateService } from './services/state.service';

export const adminGuard: CanActivateFn = async () => {
  const stateService = inject(StateService);
  const router = inject(Router);

  if (stateService.getUserState()?.roles.includes('Admin')) {
    return true;
  }

  await router.navigate(['/home']);
  return false;
};
